export * from "./CameraView-component";
export { default } from "./CameraView-component";
